import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import LayoutStyles from "../../../../toolkit/baseStyles/index";
import Header, { HeaderType } from "../header/index";
import Footer from "../footer/index";
import Modals from "../../../../Modals/containers/modals/index";
import SessionAndPhoneGate, {
  AdminPhonePromptBar,
} from "../../SessionAndPhoneGate";
import SystemNotificationBannerStack from "../../systemNotifications/SystemNotificationBannerStack";

interface Props {
  headerType: HeaderType;
  children?: React.ReactNode;
}

class Layout extends React.Component<Props, void> {
  render() {
    const headerType = this.props.headerType
      ? this.props.headerType
      : HeaderType.admin;
    return (
        <LayoutStyles>
        <div className={s.gateStack}>
          <SessionAndPhoneGate />
        </div>
        <Header headerType={headerType} />
        <SystemNotificationBannerStack />
        <div className={s.footerPadding}>{this.props.children}</div>
        <Modals />
        <div className={s.bottomDock}>
          <Footer stacked />
          <AdminPhonePromptBar />
        </div>
      </LayoutStyles>
    );
  }
}

export default withStyles(s)(Layout);
